export default __webpack_public_path__ + "static/media/logo.036a17b8.png";